module.exports = __webpack_public_path__ + "img/robot-swiper-img2.5b5cc3f5.png";